import React, { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAssociarAtividades = ({ roteiro, onChange = () => {} }) => {
  const [modalAssociacaoAtividade, setModalAssociacaoAtividade] = useState({ show: false });
  const [tipoAtividade, setTipoAtividade] = useState(1);

  const { request, data, errors, isLoading } = useApiClient();

  const associarAtividadesHandler = useCallback(() => {
    const payload = modalAssociacaoAtividade.atividades.map((item) => ({
      sequencialRoteiro: roteiro.sequencialRoteiro,
      sequencialAtividade: item.chave,
      finalidade: tipoAtividade,
    }));
    request(apiRoutes.fiscalizacao.parametrizacao.associarAtividadesRoteiro, payload);
  }, [request, tipoAtividade, roteiro.sequencialRoteiro, modalAssociacaoAtividade.atividades]);

  useEffect(() => {
    if (data) {
      toast.success("Atividades Associadas com sucesso. ");
      onChange();
    }
    if (errors) {
      toast.error(errors.message ?? "Erro durante a associação das atividades. ");
    }
    setModalAssociacaoAtividade({ show: false });
  }, [data, errors, onChange]);

  const onAddHandler = useCallback(
    (atividades) => {
      setModalAssociacaoAtividade({ atividades, show: true });
    },
    [setModalAssociacaoAtividade],
  );

  const associarAtividadesModal = (
    <EfisModal
      title={roteiro.nome}
      show={modalAssociacaoAtividade.show}
      closeHandler={() => setModalAssociacaoAtividade({ show: false })}
      confirmationHandler={associarAtividadesHandler}
      loadingConfirmationAction={isLoading}
      body={
        <Form.Group>
          <Form.Label>Tipo de Atividade:</Form.Label>
          <Form.Control
            as="select"
            id="finalidade"
            name="finalidade"
            value={tipoAtividade}
            onChange={(e) => setTipoAtividade(e.target.value)}
          >
            <option key="0" value="0">
              Início
            </option>
            <option key="1" value="1">
              Seguimento
            </option>
            <option key="2" value="2">
              Encerramento
            </option>
          </Form.Control>
        </Form.Group>
      }
    />
  );

  return {
    associarAtividadesModal,
    onAddHandler,
  };
};

export default useAssociarAtividades;
